import { ClassProvider } from '@angular/core';

import { Types } from '../../../domain/types.domain';
import { GetPublicCityListService } from '../../../domain/city/services/get-public-city-list.service';

export class GetPublicCityListServiceInstruction implements ClassProvider {
  provide = Types.GetPublicCityListService;
  deps = [Types.Settings, Types.CityRepository];
  useClass = GetPublicCityListService;
}
